@if (typingUsers.length > 0) {
    <div class="typing-indicator">
    <span class="typing-animation">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </span>
        <span class="typing-text">{{ getTypingMessage() }}</span>
    </div>
}
